var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterArrowDownNoBorderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99965 1C8.13226 1 8.25944 1.05268 8.35321 1.14645C8.44698 1.24021 8.49965 1.36739 8.49965 1.5V13.293L11.6457 10.146C11.7395 10.0521 11.8669 9.99937 11.9997 9.99937C12.1324 9.99937 12.2598 10.0521 12.3537 10.146C12.4475 10.2399 12.5003 10.3672 12.5003 10.5C12.5003 10.6328 12.4475 10.7601 12.3537 10.854L8.35365 14.854C8.30721 14.9006 8.25203 14.9375 8.19129 14.9627C8.13054 14.9879 8.06542 15.0009 7.99965 15.0009C7.93389 15.0009 7.86877 14.9879 7.80802 14.9627C7.74728 14.9375 7.6921 14.9006 7.64565 14.854L3.64565 10.854C3.55177 10.7601 3.49902 10.6328 3.49902 10.5C3.49902 10.3672 3.55177 10.2399 3.64565 10.146C3.73954 10.0521 3.86688 9.99937 3.99966 9.99937C4.13243 9.99937 4.25977 10.0521 4.35366 10.146L7.49965 13.293V1.5C7.49965 1.36739 7.55233 1.24021 7.6461 1.14645C7.73987 1.05268 7.86705 1 7.99965 1Z",
    fill: "#00948B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterArrowDownNoBorderIcon);
export default __webpack_public_path__ + "static/media/filter-arrow-down-no-border-icon.b02f5bd1a341372ca7b768c4441a51d2.svg";
export { ForwardRef as ReactComponent };